import { AttestationType } from "../enums/attestation-type.enum";
import { FALSE, TRUE } from "../constants/general.constants";

export const attestationTrameMapping: Record<AttestationType, Record<typeof TRUE | typeof FALSE, string>> = {
  [AttestationType.ATTASSU]: {
    [FALSE]: "contactUsForm.attestation.ATTASSU.false",
    [TRUE]: "",
  },
  [AttestationType.ATTTELETRAVAIL]: {
    [FALSE]: "contactUsForm.attestation.ATTTELETRAVAIL.false",
    [TRUE]: "",
  },
  [AttestationType.ATTSCO]: {
    [FALSE]: "",
    [TRUE]: "",
  },
  [AttestationType.ATTLOCSALLE]: {
    [FALSE]: "contactUsForm.attestation.ATTLOCSALLE.false",
    [TRUE]: "contactUsForm.attestation.ATTLOCSALLE.true",
  },
  [AttestationType.ATTLOCVAC]: {
    [FALSE]: "contactUsForm.attestation.ATTLOCVAC.false",
    [TRUE]: "contactUsForm.attestation.ATTLOCVAC.true",
  },
  [AttestationType.ATTRCVP]: {
    [FALSE]: "contactUsForm.attestation.ATTRCVP.false",
    [TRUE]: "contactUsForm.attestation.ATTRCVP.true",
  },
};
